const overrides = window.aemq_env || {}

export const VUE_APP_I18N_LOCALE = overrides.VUE_APP_I18N_LOCALE || process.env.VUE_APP_I18N_LOCALE
export const VUE_APP_I18N_FALLBACK_LOCALE = overrides.VUE_APP_I18N_FALLBACK_LOCALE || process.env.VUE_APP_I18N_FALLBACK_LOCALE
export const VUE_APP_ROOT_API = overrides.VUE_APP_ROOT_API || process.env.VUE_APP_ROOT_API
export const VUE_APP_GRAPHQL_HTTP = overrides.VUE_APP_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP
export const VUE_APP_CMS_ENDPOINT_URL = overrides.VUE_APP_CMS_ENDPOINT_URL || process.env.VUE_APP_CMS_ENDPOINT_URL
export const VUE_APP_CMS_ENDPOINT_ACCESS_TOKEN =
  overrides.VUE_APP_CMS_ENDPOINT_ACCESS_TOKEN || process.env.VUE_APP_CMS_ENDPOINT_ACCESS_TOKEN
